var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.219668 0.219668C0.512558 -0.0732225 0.987437 -0.0732225 1.2803 0.219668L3.25 2.1894L5.2197 0.219688C5.5126 -0.0732025 5.9874 -0.0732025 6.2803 0.219688C6.5732 0.512578 6.5732 0.987457 6.2803 1.2803L4.3107 3.25L6.2803 5.2197C6.5732 5.5125 6.5732 5.9874 6.2803 6.2803C5.9874 6.5732 5.5125 6.5732 5.2196 6.2803L3.25 4.3107L1.2804 6.2803C0.987458 6.5732 0.512578 6.5732 0.219688 6.2803C-0.0732025 5.9874 -0.0732025 5.5126 0.219688 5.2197L2.1894 3.25L0.219668 1.2803C-0.0732225 0.987437 -0.0732225 0.512558 0.219668 0.219668Z",
    fill: "#EDEAFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagX);
export default __webpack_public_path__ + "static/media/tag_x.363b1d591907969d97755640c6800a46.svg";
export { ForwardRef as ReactComponent };